import { Button } from "@/components/ui/button/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog/Dialog";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
};

export function ConfirmDeleteDialog({ isOpen, onClose, onConfirm, title, description }: Props) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md bg-card border-border">
        <DialogHeader>
          <DialogTitle className="text-foreground font-lsemibold">{title}</DialogTitle>
        </DialogHeader>
        <div className="py-4 text-foreground/80 font-lregular">
          {description}
        </div>
        <DialogFooter className="flex gap-2">
          <Button type="button" variant="ghost" onClick={onClose} className="font-lmedium">
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={onConfirm} className="font-lmedium shadow-lg">
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}